export const RTL_LANGUAGES = ['ar'];

export function isRtlLanguage(lng) {
  return RTL_LANGUAGES.includes(lng);
}
